import { varGlobal } from "../shared/varGlobal";
import { Injectable } from "@angular/core";
import { AppSettingsService } from "./appsettings.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Facent } from "../pages/admin/pageAdminFactVisu/factvisu/facent";
import { Faclig } from "../pages/admin/pageAdminFactVisu/factvisu/faclig";

/**
 *  Service de gestion de visualisation facture
 */
@Injectable()
export class FactvisuService extends BehaviorSubject<any[]> {
  /** Chemin vers l'API */
  public w_baseUrl: string = "";

  /** propriétés utilisées dans Factvisu  **/
  public facentIdVisu = new BehaviorSubject<number>(0);
  currentFacentId = this.facentIdVisu.asObservable();

  /** Affichage du formulaire  **/
  public f_facentDialog = new BehaviorSubject<boolean>(false);
  currentFacentDialog = this.f_facentDialog.asObservable();

  /** Proprietes facent object  **/
  ifacture: Facent = {
    facentId: 0,
    numFacent: 0,
    dateEcheanceFac: "",
    dateEditFac: "",
    mntTotalHtFac: 0,
    mntTvaFac: 0,
    mntTotalTtcFac: 0,
    tvaTauxFac: 0
  };
  public facture = new BehaviorSubject<Facent>(this.ifacture);
  currentFacture = this.facture.asObservable();

  /** Proprietés listeFaclig **/
  ifaclig: Faclig = {
    facligId: 0,
    numfaclig: 0,
    obsEditFaclig: "",
    puFaclig: 0,
    qteFaclig: 0,
    mntTotalHtFaclig: 0
  };
  aFaclig: Faclig[] = [this.ifaclig];

  public lstFaclig = new BehaviorSubject<Faclig[]>(this.aFaclig);
  currentListFaclig = this.lstFaclig.asObservable();

  /**
   * Constructeur
   */
  constructor(
    public http: HttpClient,
    public s_appsettings: AppSettingsService,
    public s_global: varGlobal
  ) {
    super([]);
    this.w_baseUrl = this.s_global.pathAPI + "/factvisu";
  }

  /** Data suivante */
  public proc_next(data) {
    if (data != null) super.next(data);
    else super.next([]);
  }

  /**
   * Fonction pour changement de status toggle Valeur
   */
  public proc_changeStatusFacture(facentId: number): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/changeStatusFacture/${facentId}`,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction pour generer la facture en format .pdf
   */
  public proc_genererFacture(
    facentId: number,
    f_mail: boolean,
    destinataire: string
  ): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/genererFacture`,
      JSON.stringify({
        facentId: facentId,
        fmail: f_mail,
        destinataire: destinataire
      }),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**Procedure  Change facentId  **/
  public changeFacentId(facentId: number) {
    this.facentIdVisu.next(facentId);
  }

  /**  Change Affichage dialog facture   **/
  public changeFacentDialog(facentDialog: boolean) {
    this.f_facentDialog.next(facentDialog);
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/services/factvisu.service.ts